/**
 * Body shape for company question create/update (visual editor).
 */
export function buildEditorApiPayload(question) {
    return {
        name: question.name,
        area: question.area,
        difficulty: question.difficulty,
        languages: question.languages || ['en'],
        tags: question.tags || [],
        ui: question.ui,
        actions: question.actions,
        translations: question.translations,
        type: question.type,
        personalizedKeysUsed: question.personalizedKeysUsed,
        personalizedKeysActions: question.personalizedKeysActions,
        max_score: question.max_score != null ? question.max_score : 1000,
        components: question.components || 'Behaviour',
    };
}
